import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, watch } from "vue";
import { UserModel, MoveUserAdminModel, IUserCreator } from "@truckdown/accounts";
import { IRelationshipService, RelationshipType } from "@truckdown/systems";
import { showMessage } from "../../../Utilities/Utilities";

export interface ISelectItem {
    value: string,
    display: string,
    terms?: string
}

interface IData {
    isLoading: Ref<boolean>,
    errorMessage: Ref<string>,

    accountList: Ref<ISelectItem[]>,
    accountListUnfiltered: Ref<ISelectItem[]>,
    selectedAccount: Ref<ISelectItem | null>,
    showAccountList: Ref<boolean>,
    searchTermAccount: Ref<string>,
    model: Ref<MoveUserAdminModel>
};

const getData = function (props: any) {
    let model = {
        userId: props.userProfile.id,
        toAccountId: "",
        isPrimary: false,
        isBilling: false
    } as MoveUserAdminModel;

    return {
        isLoading: ref<boolean>(false),
        errorMessage: ref<string>(""),

        accountList: ref<ISelectItem[]>([]),
        accountListUnfiltered: ref<ISelectItem[]>([]),
        selectedAccount: ref<ISelectItem | null>(null),
        showAccountList: ref<boolean>(false),
        searchTermAccount: ref<string>(""),
        model: ref<MoveUserAdminModel>(model)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        selectAccount: function (account?: ISelectItem) {
            if (account) {
                data.selectedAccount.value = account;
            } else {
                data.selectedAccount.value = null;
            }

            data.searchTermAccount.value = "";
            data.showAccountList.value = false;
        },
        moveUserAdminCancelClick: function (): void {
            ctx.emit(cancelEventName);
        },
        moveUserAdminSaveClick: async function (): Promise<void> {
            if (data.selectedAccount.value != null) {
                data.model.value.toAccountId = data.selectedAccount.value.value;

                data.errorMessage.value = "";

                if (data.selectedAccount.value?.value == props.userProfile.aid) {
                    data.errorMessage.value = "User is already on account selected."
                } else {
                    data.isLoading.value = true;

                    try {
                        let userCreator = await context.getService<IUserCreator>('IUserCreator');

                        var response = await userCreator.moveUserAdmin(data.model.value);

                        if (!response || !response.ok) {
                            console.log("Error moving user: " + response.message);
                            showMessage("Error moving user.", "danger", true, true);
                        } else {
                            showMessage("User was moved successfully.", "success", true, true);

                            window.location.href = '/accounts/admin/user/' + response.data?.id;
                        }
                    } catch (err) {
                        console.log(err);
                    } finally {
                        data.isLoading.value = false;
                    }
                }
            } else {
                data.errorMessage.value = "No Account Selected.";
            }
        }
    };
}

const getAccounts = async function (data: IData) {
    let mgr = await context.getService<IRelationshipService>('IRelationshipService');
    await mgr.search({
        tags: data.searchTermAccount.value || '',
        type: RelationshipType.Account,
        limit: 15,
        desc: false
    }).then((res) => {
        data.accountList.value = res.results.map(r => ({
            value: r.accountId,
            display: r.display,
            terms: r.id
        }));
        data.accountListUnfiltered.value = data.accountList.value;
    }).catch((reason) => {
        console.log(reason);
    });
}

const updateEventName = 'update';
const cancelEventName = 'cancel';


export default defineComponent({
    props: {
        userProfile: {
            type: Object as () => UserModel,
            required: true
        }
    },
    emits: [updateEventName, cancelEventName],
    setup: function (props, ctx) {

        console.log("GS moveUserAdmin setup() props:", props);

        let data = getData(props);
        let methods = getMethods(props, data, ctx);

        watch(() => data.searchTermAccount.value, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (newVal.length > 0) {
                    getAccounts(data);
                } else {
                    data.accountList.value = data.accountListUnfiltered.value;
                }
            }
        })

        return {
            ...data,
            ...methods
        };
    }
});


